import { lazy } from "react"

export const RolesPage = lazy(() => import("./RolesPage"))
